export const ROLES = {
  ADMINISTRADOR: 'Administrador',
  SUPERADMINISTRADOR: 'Superadministrador',
  DEUDOR: 'Deudor',
  EMISOR: 'Emisor',
  FACTOR: 'Factor',
  FONDEADOR: 'Fondeador'
} as const;

export const FACTOR_CONTEXT_ID = 'FACTOR';

export type RolUsuario = typeof ROLES[keyof typeof ROLES];

export const ROLES_ADMIN = [ROLES.ADMINISTRADOR, ROLES.SUPERADMINISTRADOR] as const;

export const esRolAdmin = (rol: string): boolean => {
  return ROLES_ADMIN.includes(rol as typeof ROLES_ADMIN[number]);
};
